import { ITEM_TYPES } from './ItemTypes';
export var COMPONENT_ITEM_TYPES = [
    ITEM_TYPES.BREADCRUMBS_COMPONENT,
    ITEM_TYPES.VIDEO_COMPONENT,
    ITEM_TYPES.GIFT_CARD,
    ITEM_TYPES.REVIEWS_COMPONENT,
    ITEM_TYPES.STORES_GALLERY_COMPONENT,
    ITEM_TYPES.PROGRAMS_COMPONENT,
    ITEM_TYPES.SERVICES_COMPONENT,
    ITEM_TYPES.RESTAURANTS_MENU_COMPONENT,
    ITEM_TYPES.PAGINATED_COMPONENT,
    ITEM_TYPES.EVENTS_LIST_COMPONENT,
];
